import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE from "../config";   // ✅ added

function Signup() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      // ❗ FIXED — using API_BASE for local+live
      const res = await fetch(`${API_BASE}/signup.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      setLoading(false);

      if (data.success) {
        setMessage("✅ " + data.message);
        setForm({ name: "", email: "", password: "", phone: "" });
        setTimeout(() => navigate("/login"), 1000);
      } else {
        setMessage("❌ " + data.message);
      }
    } catch (err) {
      setLoading(false);
      setMessage("❌ Server error. Please try again.");
    }
  };

  return (
    <div className="auth-container">
      {/* Inline Styles */}
      <style>{`
        .auth-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(to right, #faa9a9, #eec76b, #90e8f4);
          font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
          flex-direction: column;
        }
        .auth-container h2 {
          text-align: center;
          margin-bottom: 10px;
          font-size: 28px;
          color: #300752;
        }
        form {
          background: #fff;
          padding: 40px 30px;
          border-radius: 12px;
          width: 100%;
          max-width: 400px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
          display: flex;
          flex-direction: column;
        }
        form input {
          width: 100%;
          padding: 10px 12px;
          border-radius: 8px;
          border: 1px solid #ccc;
          outline: none;
          font-size: 14px;
          margin-bottom: 15px;
          transition: 0.2s ease;
        }
        form input:focus {
          border-color: #800080;
          box-shadow: 0 0 5px rgba(128, 0, 128, 0.3);
        }
        form button {
          width: 100%;
          margin-top: 10px;
          padding: 12px;
          background: linear-gradient(to right, #fba800, #f70077);
          border: none;
          color: white;
          font-weight: bold;
          font-size: 15px;
          border-radius: 8px;
          cursor: pointer;
          transition: background 0.3s ease;
        }
        form button:hover {
          background: linear-gradient(to right, #f70077, #fba800);
        }
        .error {
          color: red;
          text-align: center;
          margin-bottom: 10px;
          font-size: 14px;
        }
        .success {
          color: green;
          text-align: center;
          margin-bottom: 10px;
          font-size: 14px;
        }
        p {
          text-align: center;
          margin-top: 15px;
        }
        p a {
          color: #800080;
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        }
      `}</style>

      <h2>Signup</h2>
      <form onSubmit={handleSubmit} autoComplete="off">
        <input type="text" name="name" placeholder="Full Name" value={form.name} onChange={handleChange} required />
        <input type="email" name="email" placeholder="Email Address" value={form.email} onChange={handleChange} required />
        <input type="password" name="password" placeholder="Password" value={form.password} onChange={handleChange} required minLength={8} />
        <input type="tel" name="phone" placeholder="Phone Number" value={form.phone} onChange={handleChange} required pattern="[0-9]{10,15}" />
        <button type="submit" disabled={loading}>{loading ? "Signing up..." : "Signup"}</button>
      </form>

      {message && <p className={message.startsWith("✅") ? "success" : "error"}>{message}</p>}

      <p>
        Already have an account? <a href="/login">Login here</a>
      </p>
    </div>
  );
}

export default Signup;
